import { createAsyncThunk } from '@reduxjs/toolkit';
import createApiFromState from 'api/createApiFromState';

const datasetSetOwner = createAsyncThunk(
  'dataset/set-owner',
  async ({ id, owner }, { dispatch, getState }) => {
    const api = createApiFromState({ dispatch, getState });
    const response = await api.put(`/api/datasets/${id}/owner`, { owner });
    return response.data;
  },
);

export { datasetSetOwner };
